const designButton = document.querySelector('#customers_canvas_button');
  designButton.addEventListener('click', function() {
  let quantity = getQuantity();
  var search = "?view=customers-canvas-se&quantity=" + quantity;
  const variant = getQueryParam("variant");
  if(variant){
    search += "&variant=" + variant;
  }
  window.location.search = search;
});

function getQueryParam(key) {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  return urlParams.get(key);
}

function getQuantity() {
  const qty = (document.querySelector('.quantity__input') || document.querySelector('.product-quantity'))?.value;
  return (!!qty) ? qty : 1;
}